import getInitData from './init-data';
import { logger } from 'packages/logger';
import { reload } from 'tradera/utils/location';
/**
 * The fetch() function is a Promise-based mechanism for programmatically making web requests in the browser;
 * The fetch implementation we're using is developer by GitHub and polyfills the API for browsers that don't contain it.
 * https://github.com/github/fetch
 */

const refreshPageIfNotAuthenticated = (statusCode) => {
    if (statusCode === 401 || statusCode === 402) {
        window.document.location = window.document.location.pathname;
    }
    return false;
};

/**
 * Checks status of Fetch response;
 * @param {object} response
 */
const checkStatus = (response) => {
    const ID = getInitData();
    const tradVersion =
        response && response.headers
            ? response.headers.get('X-Tradera-Version')
            : '';
    if (tradVersion && tradVersion !== ID.version) {
        reload(true);
    }
    if (
        response.status >= 200 &&
        response.status < 300 &&
        typeof response !== 'string'
    ) {
        return Promise.resolve(response);
    } else {
        if (refreshPageIfNotAuthenticated(response.status)) {
            const error = new Error('Du har blivit utloggad - sidan laddas om');
            logger(error, {
                contexts: {
                    response
                }
            });
        } else {
            return Promise.reject(response);
        }
    }
};

/**
 * parseJSON - don't remove res
 * @param {object} res - the response from the fetch API;
 */
const parseJSON = (res) => res.json();

/**
 * get request from server;
 * @param {string} endPoint - declare where the network request is to be made
 * @param {string} params.body - body of the request
 * @param {string} params.method - request method
 */
const get = (endPoint, params) =>
    fetch(endPoint, {
        ...params,
        method: params.method || 'POST',
        dataType: params.dataType || 'json',
        headers:
            params.headers === false
                ? ''
                : params.headers || {
                      'Content-Type': 'application/json; charset=UTF-8'
                  },
        credentials: 'include'
    })
        .then(checkStatus)
        .then(parseJSON);

export default get;
